import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import formatDate from '../utils/date';

const BloodstockSalesLink = ({
    children,
    venueUid,
    saleDate,
    lotNo,
    bloodstockDomain
}) => {
    if (!venueUid || !saleDate || !lotNo) {
        return null;
    }

    const date = formatDate(saleDate, 'Y-MM-DD');
    const url = `http://${bloodstockDomain}/sales/results/individual_home.sd?venue_id=${
        venueUid}&start_date=${date}&end_date=${date}&l=${lotNo}`;
    return (
        <a
            className="ui-link ui-link_table js-popupLink js-navigate-url"
            href={url}
        >
            {children || formatDate(saleDate, 'DDMMMYY')}
            <Svg
                iconName="right"
                size="smallChevron"
            />
        </a>
    );
};

BloodstockSalesLink.propTypes = {
    children: PropTypes.node,
    venueUid: PropTypes.number,
    saleDate: PropTypes.string,
    lotNo: PropTypes.number,
    bloodstockDomain: PropTypes.string.isRequired
};

export default BloodstockSalesLink;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/links/BloodstockSalesLink.jsx